require("@rails/ujs").start()
require("turbolinks").start()

import 'jquery';

import 'application/application';
